<template>
  <div class="index" style="display: flex;align-items: center;justify-content: center;height: 100vh;">
    <div style="font-size: 24px;">Website is in maintenance</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headerHeight: 996,
      timer: null,
      rotateArr: [0, -20, 0, 20],
      rotateY: 0,
      index: 0,
      stakingList: [
        {img: '../../static/images/svg/oasis.svg', url: '/oasis-network-staking', coin: 'Oasis Network', type: 'ROSE', yield: '12%'},
        {img: '../../../static/images/svg/XTZ.svg', url: '/tezos-staking', coin: 'Tezos', type: 'XTZ', yield: '5.8%'},
        {img: '../../static/images/svg/ada.svg', url: '/cardano-staking', coin: 'Cardano', type: 'ADA', yield: '4.5%'},
        {img: '../../static/images/svg/trx.svg', url: '/tron-staking', coin: 'Tron', type: 'TRX', yield: '5.6%'},
        {img: '../../static/images/svg/IRIS.svg', url: '/irisnet-staking', coin: 'IRISnet', type: 'IRIS', yield: '10%'},
        {img: '../../static/images/svg/CTK.svg', url: '/certiK-staking', coin: 'CertiK', type: 'CTK', yield: '25%'},
        {img: '../../static/images/svg/gravity.svg', url: '/gravity-bridge-staking', coin: 'Gravity', type: 'GRAV', yield: '38.8%'}
        // {img: '../../../static/images/svg/band.svg', url: '/Band-Protocol-staking', coin: 'Band Protocol', type: 'BAND'}
      ]
    }
  },
  created () {
    if ($(window).width() <= 700) {
      this.headerHeight = 400
    } else {
      this.headerHeight = $(window).height() - 90
    }
    $(window).resize(() => {
      if ($(window).width() <= 700) {
        this.headerHeight = 400
      } else {
        this.headerHeight = $(window).height() - 90
      }
    })
  },
  mounted () {
    $('.staking-choose-list li').mouseenter(function () {
      $('.staking-choose-msg-box li span').css({border: 0})
      $('.staking-choose-msg-box li b').hide().siblings('i').hide()
      $('.staking-choose-msg-box li').eq($(this).index()).find('span').css({'border-left': '1px solid #2E9728'}).find('b').show().siblings('i').show()
    })
    let dom = document.getElementsByClassName('index-header')[0]
      var renderer = new THREE.WebGLRenderer({ antialias: true,
        alpha: true });
      renderer.setSize(dom.offsetWidth, dom.offsetHeight);
      renderer.setClearColor(0, 0, 0, 0);
      dom.appendChild(renderer.domElement);
      var camera = new THREE.PerspectiveCamera(50, dom.offsetWidth / dom.offsetHeight, 0.1, 1000);
      camera.position.set(0, 0, 75);
// var controls = new THREE.OrbitControls(camera);
// controls.target = new THREE.Vector3(0, 0, 20);
// controls.update();
      var scene = new THREE.Scene();
      var globalMaterial = new THREE.SpriteMaterial({
          map: new THREE.CanvasTexture(generateSprite()),
          // blending: THREE.AdditiveBlending
      });
      var particles = [];
      var numOfParticles = 20000;
      var sigma = 10;
      var rho = 22;
      var beta = 8 / 3;
      var dt = 0.0085;
      for (var i = 0; i < numOfParticles; i++) {
          var material = new THREE.Sprite(globalMaterial);
          var x = void 0,
              y = void 0,
              z = void 0;
          if (i == 0) {
              x = y = z = 0.1;
          } else {
              x = particles[i - 1].material.position.x;
              y = particles[i - 1].material.position.y;
              z = particles[i - 1].material.position.z;
              var dx = sigma * (y - x);
              var dy = x * (rho - z) - y;
              var dz = x * y - beta * z;
              x += dx * dt;
              y += dy * dt;
              z += dz * dt;
          }
          var particle = new Particle(material, x, y, z);
          particle.material.scale.x = .3;
          particle.material.scale.y = .3;
          particle.material.scale.z = .3;
          particle.material.position.x = x;
          particle.material.position.y = y;
          particle.material.position.z = z;
          scene.add(particle.material);
          particles.push(particle);
      }
      dt = .0005;
      function render() {
          renderer.render(scene, camera);
          renderer.autoClearColor = false;
          for (var i = 0; i < numOfParticles; i++) {
              var _x = particles[i].material.position.x;
              var _y = particles[i].material.position.y;
              var _z = particles[i].material.position.z;
              var _dx = sigma * (_y - _x);
              var _dy = _x * (rho - _z) - _y;
              var _dz = _x * _y - beta * _z;
              _x += _dx * dt;
              _y += _dy * dt;
              _z += _dz * dt;
              particles[i].material.position.x = _x;
              particles[i].material.position.y = _y;
              particles[i].material.position.z = _z;
          }
          // controls.update();
          requestAnimationFrame(render);
      }
      render();
      function Particle(material, x, y, z) {
          this.material = material;
          this.material.position.x = x;
          this.material.position.y = y;
          this.material.position.z = z;
      }
      function generateSprite() {
          var canvas = document.createElement('canvas');
          canvas.width = 12;
          canvas.height = 12;

          var context = canvas.getContext('2d');
          var gradient = context.createRadialGradient(canvas.width / 2, canvas.height / 2, 0, canvas.width / 2, canvas.height / 2, canvas.width / 2);
          // gradient.addColorStop(0, 'rgba(255,255,255,1)');
          // gradient.addColorStop(0.2, 'rgba(255,50,50,1)');
          // gradient.addColorStop(0.2, 'rgba(40, 237, 4, 1)');
          gradient.addColorStop(0, '#e8e6e3');
          gradient.addColorStop(0.2, '#9ccd8b');
          gradient.addColorStop(0.4, '#2E9728');
          gradient.addColorStop(1, '#171a17');
          // gradient.addColorStop(1, 'rgba(255,255,255,1)');

          context.fillStyle = gradient;
          context.fillRect(0, 0, canvas.width, canvas.height);

          return canvas;
      }
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.index{
  background-color: #FFFFFF;
}
.index-header{
  background-color: #171A17;
  display: flex;
  align-items: center;
  justify-content: center;
}
.index-future{
  width: 100%;
  font-size: 160px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #1E221E;
  text-shadow: -2px 0px 1px #3c3f3c, 0px 2px 1px #000000;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.staking-services{
  max-width: 1400px;
  width: 100%;
  padding: 240px 20px 0 20px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.staking-services-stip{
  flex: 1;
}
.staking-services-stip h3{
  font-size: 56px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A9A9A9;
}
.staking-services-stip p{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #535353;
  margin: 20px 0;
}
.staking-services-stip span{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #2E9728;
  cursor: pointer;
}
.staking-services-stip span i{
  margin-left: 10px;
}
.staking-list{
  width: 885px;
  max-height: 532px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: 30px;
}
.staking-list::-webkit-scrollbar{
  width:8px;
  height:8px;
  background-color: #A0D5A0;
}
.staking-list::-webkit-scrollbar-track{
    background: #F5FAF5;
}
.staking-list::-webkit-scrollbar-thumb{
    background: #A0D5A0;
    border-radius:4px;
}
.staking-list::-webkit-scrollbar-thumb:hover{
    background: #A0D5A0;
}
.staking-list::-webkit-scrollbar-corner{
    background: #A0D5A0;
}
.staking-list ul {
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
}
.staking-list ul li{
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 40px 10px 10px;
  background: #FFFFFF;
  box-shadow: 0px 1px 6px 0px #D8D8D8;
  border-radius: 54px;
  margin: 0 2% 27px 3%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.staking-list ul li:hover{
   box-shadow: 0px 1px 24px 0px #D8D8D8;
}
.staking-list-coin{
  display: flex;
  align-items: center;
}
.staking-list ul li img{
  width: 82px;
  height: 82px;
}
.staking-list-coin div{
  margin: 0 20px;
}
.staking-list-coin div p{
  font-size: 20px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  line-height: 28px;
}
.staking-list-coin div span{
  font-size: 16px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #777777;
}
.staking-list-coin-yield{
  font-size: 20px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #3EA338;
}
.staking-choose{
  max-width: 1300px;
  width: 100%;
  margin: 300px auto;
  padding: 0 20px;
  display: flex;
  flex-direction:row-reverse;
  justify-content: space-between;
}
.staking-choose-msg{
  width: 582px;
  height: 710px;
  background: #F3F3F3;
  box-shadow: 6px 6px 21px 0px #D6D6D6, 0px 6px 5px 0px #F3F3F3, 2px 0px 5px 5px #fdfdfd inset;
  border-radius: 40px;
  padding: 30px;
}
.staking-choose-msg .staking-choose-msg-box{
  width: 100%;
  height: 100%;
  background: #363636;
  border-radius: 30px;
  padding: 15px 30px 30px 30px;
}
.staking-choose-msg .staking-choose-msg-box div{
  margin-bottom: 80px;
}
.staking-choose-msg .staking-choose-msg-box div span{
  font-size: 30px;
  color: #499445;
}
.staking-choose-msg .staking-choose-msg-box ul li{
  font-size: 14px;
  /* font-family: 'PingFangSC-Medium'; */
  font-weight: 400;
  color: #D6D6D6;
  display: flex;
  margin-bottom: 30px;
}
.staking-choose-msg .staking-choose-msg-box ul li p span{
  position: relative;
}
.staking-choose-msg .staking-choose-msg-box ul li p span b{
  position: absolute;
  white-space: nowrap;
  padding: 10px;
  background: #2E9728;
  left: -55px;
  top: -60px;
  z-index: 2;
  display: none;
}
.staking-choose-msg .staking-choose-msg-box ul li p span i{
    position: absolute;
    width: 10px;
    height: 10px;
    background: #2E9728;
    left: -6px;
    top: -26px;
    transform: rotateZ(45deg);
    display: none;
}
.staking-choose-msg .staking-choose-msg-box ul li img{
  width: auto;
  height: 16px;
  margin-right: 10px;
  margin-top: 4px;
}
.staking-choose-list{
  margin-top: 150px;
}
.staking-choose-list h3{
  font-size: 56px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A5AAA5;
}
.staking-choose-list ul{
  display: flex;
  flex-wrap: wrap;
  width: 480px;
  margin-top: 50px;
}
.staking-choose-list ul li{
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
  margin-bottom: 30px;
  margin-right: 20px;
  cursor: pointer;
}
.staking-choose-list ul li:hover{
  color: #2E9728;
}
.staking-mission{
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding: 0 20px;
}
.staking-mission h3{
  font-size: 50px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A5AAA5;
}
.staking-mission p{
  max-width: 730px;
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #535353;
  margin: 30px auto;
}
.staking-mission span{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #2E9728;
  cursor: pointer;
}
.staking-mission span i{
  margin-left: 5px;
}
.staking-bottom-bg{
  width: 100%;
  height: 650px;
  background: url('../../static/images/index/bg.png') no-repeat;
  background-size: 100% 100%;
}
@media (max-width: 1200px) {
  .cube,.side{
    width: 500px;
    height: 500px;
  }
  .front {
    transform: translateZ(250px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(250px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(250px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(250px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(250px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(250px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .index-future{
    font-size: 100px;
  }
  .staking-list{
    max-width: 700px;
    width: 100%;
  }
  .staking-services{
    padding-top: 180px;
  }
  .staking-choose{
    margin: 180px auto;
  }
  .staking-list ul li{
    width: 45%;
  }
  .staking-list ul li img{
    width: 60px;
    height: 60px;
  }
  .staking-list-coin div p{
    font-size: 18px;
  }
  .staking-services-stip h3,.staking-choose-list h3,.staking-mission h3{
    font-size: 40px;
  }
  .staking-services-stip p,.staking-mission p{
    font-size: 16px;
  }
  .staking-services-stip span.staking-mission span{
    font-size: 16px;
  }
  .staking-choose-list ul li{
    font-size: 18px;
  }
  .staking-choose-msg{
    max-width: 540px;
    width: 100%;
    height: 650px;
    margin-right: 40px;
  }
  .staking-bottom-bg{
    height: 380px;
  }
}
@media (max-width: 960px) {
  .cube,.side{
    width: 300px;
    height: 300px;
  }
  .front {
    transform: translateZ(150px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(150px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(150px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(150px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(150px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(150px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .staking-services{
    display: block;
  }
  .staking-services-stip{
    text-align: center;
  }
  .staking-list{
    margin: 20px auto;
  }
  .staking-services{
    padding-top: 100px;
  }
  .staking-choose{
    margin: 100px auto;
    display: block;
  }
  .staking-choose-list h3{
    text-align: center;
  }
  .staking-choose-list ul{
    margin: 30px auto;
  }
  .staking-choose-list ul li{
    width: 50%;
    margin-right: 0;
  }
  .staking-choose-msg{
    margin: 0 auto;
  }
  .index-future{
    padding: 0 50px;
  }
}
@media (max-width: 720px) {
  .cube,.side{
    width: 200px;
    height: 200px;
  }
  .front {
    transform: translateZ(100px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(100px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(100px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(100px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(100px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(100px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .index-future{
    font-size: 65px;
  }
  .staking-list ul li img{
    width: 30px;
    height: 30px;
  }
  .staking-list-coin div p{
    font-size: 16px;
  }
  .staking-list-coin div span{
    font-size: 14px;
  }
  .staking-list-coin-yield{
    font-size: 16px;
  }
  .staking-choose-msg{
    height: 580px;
  }
}
@media (max-width: 634px) {
  .staking-list ul{
    display: block;
  }
  .staking-list ul li{
    width: 270px;
    margin: 15px auto;
  }
  .staking-services-stip h3,.staking-choose-list h3,.staking-mission h3{
    font-size: 30px;
  }
  .staking-choose-list{
    margin-top: 100px;
  }
  .staking-bottom-bg{
    height: 220px;
  }
  .staking-choose-list ul{
    width: 100%;
  }
  .staking-choose-msg .staking-choose-msg-box div span{
    font-size: 20px;
  }
  .staking-choose-msg .staking-choose-msg-box div{
    margin-bottom: 80px;
  }
  .staking-choose-msg .staking-choose-msg-box ul li{
    margin-bottom: 10px;
  }
  .staking-choose-msg{
    height: auto;
  }
  .index-future{
    font-size: 50px;
  }
}
@media (max-width: 360px) {
  .index-future{
    padding: 0 20px;
    font-size: 40px;
  }
  .staking-choose-msg{
    padding: 10px;
  }
  .staking-choose-msg .staking-choose-msg-box div{
    margin-bottom: 50px;
  }
  .staking-list ul li{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue